/** Badge grid density on /badges. Device preference: localStorage only, never the DB. */
export type BadgeSize = 'S' | 'M' | 'L'

export const BADGE_SIZE_PX: Record<BadgeSize, number> = { S: 52, M: 96, L: 144 }
export const BADGE_SIZE_STORAGE_KEY = 'badges-size'
const DEFAULT_SIZE: BadgeSize = 'M'

export const isBadgeSize = (v: unknown): v is BadgeSize => v === 'S' || v === 'M' || v === 'L'

export const loadBadgeSize = (): BadgeSize => {
    try {
        const stored = localStorage.getItem(BADGE_SIZE_STORAGE_KEY)
        return isBadgeSize(stored) ? stored : DEFAULT_SIZE
    } catch {
        return DEFAULT_SIZE
    }
}

export const persistBadgeSize = (size: BadgeSize): void => {
    try {
        localStorage.setItem(BADGE_SIZE_STORAGE_KEY, size)
    } catch {
        // private window / quota: the choice lives for this session only
    }
}
